export default {
  "Update case success": "Le cas a été mis à jour avec succès",
  ru: "RU",
  en: "EN",
  languages: {
    ru: "russe",
    en: "anglais",
    ar: "arabe",
    es: "espagnol",
    fa: "persan",
    kz: "kazakh",
    pt: "portugais",
    fr: "Français",
  },
  CoursesTitle: "Cours | «Third Opinion»",
  Module_AI: {
    title: "IA",
    desc: "Services d'IA pour l'imagerie médicale",
  },
  Module_edu: {
    title: "Éducation",
    desc: "Simulateurs de diagnostic et cours pour médecins",
  },
  Module_community: {
    title: "Communauté",
    desc: "Partage de connaissances entre médecins sur des cas cliniques",
  },
  Profile: "Profil",
  Subscription: "Abonnement",
  "Go to site": "Site web",
  "Access after pay": "La leçon est terminée",
  Exit: "Se déconnecter",
  MY: "MON",
  Home: "Accueil",
  "Mobile banner text : demo":
    "Créez un compte et obtenez un accès complet aux services et simulateurs d'IA",
  Platform: "PLATEFORME POUR LES MÉDECINS",
  "Platform info":
    "Assistants IA, simulateurs de diagnostic et cours pour votre croissance continue",
  "Download app": "Télécharger l'application Android",
  "Home title": "Accueil | «Third Opinion»",
  AI: "IA",
  edu: "Éducation",
  community: "Communauté",
  "Your courses": "Vos cours",
  "Recomended courses": "Cours recommandés",
  Courses: "Cours",
  Calculator: "Calculatrice",
  Plug: "Intégration",
  "Go to": "Aller",
  Case: "Cas",
  Cases: "Cas",
  "Case success": "Complété",
  "Case unsuccess": "Non terminé",
  Modality: "Modalité",
  "Page title tail": " | «Third Opinion»",
  "Cant find service?": "Besoin d'un autre service ?",
  "Text us": "Envoyez-nous un SMS",
  "I need AI for...": "J'ai besoin d'IA pour...",
  "Thx for reply": "Merci pour votre retour !",
  Send: "Envoyer",
  Sent: "Envoyé",
  "Cannot loading reply -- adblock":
    "Échec de la demande. Veuillez désactiver les extensions de navigateur telles que VPN et Adblocker.",
  Favorites: "Favoris",
  "Cases about 1": "Ajoutez votre cas",
  "Cases about 2":
    "Partagez un cas clinique au format DICOM et obtenez l’avis de vos collègues.",
  "Cases about 3": "Comment anonymiser et protéger les données ?",
  "Add case": "Ajouter un cas",

  All: "Tout",
  "I upload": "Télécharger",
  drafts: "Brouillons",
  draft: "Brouillon",
  "Case v2": "Cas",
  "Open study": "Étude ouverte",
  Comments: "Commentaires",
  "Comment placeholder": "Ajouter un commentaire...",
  "Favorites about 1": "Rien ici pour le moment, cliquez sur l'icône",
  "Favorites about 2": "sur un cas intéressant pour l'ajouter aux favoris",
  "Comment screen info 1": "Pour joindre une capture d'écran, ",
  "Comment screen info 2": "ouvrir l'étude dans la visionneuse",
  Download: "Télécharger",
  "Record Date": "Enregistrement de cours",
  "Request a course": "Rejoindre",
  "Request a course doned": "Vous avez laissé une demande",
  "Forgot password?": "Mot de passe oublié ?",
  "Reset password": "Réinitialiser le mot de passe",
  "Reset password v2": "Réinitialiser le mot de passe",
  "Reset password about":
    "Saisissez l'adresse e-mail utilisée pour vous inscrire. Nous vous enverrons les instructions pour réinitialiser votre mot de passe.",
  "Reset password about after":
    "Un lien de réinitialisation du mot de passe a été envoyé à votre adresse e-mail",
  "Back to prev page": "Retour à la page précédente",
  Email: "E-mail",
  "Not valid email": "E-mail invalide",
  "Not found email": "E-mail non enregistré",
  EmailAlreadyRegistered: "E-mail déjà enregistré",
  NotActivatedAccount: "Compte non activé",
  "Back to login": "Retour à la connexion",
  "Email not come?": "Vous n'avez pas reçu l'email ?",
  "Write to support": "Contacter le support",
  "Create new password": "Créer un nouveau mot de passe",
  "Password confirm": "Confirmer le mot de passe",
  "Min 8": "Au moins 8 caractères",
  "Two inputs don't match!": "Les mots de passe ne correspondent pas",
  "Update password": "Mettre à jour le mot de passe",
  "Password updated": "Mot de passe mis à jour",
  "Invalid password token": "Lien invalide, veuillez réessayer",
  "Unknown user": "Utilisateur inconnu",
  "Attach image": "Joindre une image",
  Remove: "Retirer",
  Complain: "Rapport",
  "Complain sent": "Votre rapport a été envoyé avec succès",
  owner: "Auteur du cas",
  assistant: "Conservateur",
  "Answers 1": "répondre",
  "Answers 2": "réponses",
  "Answers 3": "réponses",
  "Add answer": "Répondre",
  "Collapse answers": "Réduire les réponses",
  "Image only": "<Image>",
  "Cannot upload from mobile":
    "Vous pouvez télécharger des études au format DICOM depuis votre ordinateur de bureau",
  "Password rule": "Tapez au moins 8 symboles, 1 lettre et 1 chiffre",
  ReferenceCursors: "C - Curseurs de référence",
  "bad browser for mpr":
    "MPR (peut ne pas être disponible) Nous vous recommandons d'ouvrir le site dans la dernière version du navigateur Google Chrome",
  "Service in process": "Le téléchargement n'est pas disponible",
  "Service in process about":
    "Vous pouvez toutefois découvrir les fonctionnalités du service grâce aux études de démonstration. Nous vous informerons dès que vous pourrez les réaliser.",
  "Edit case": "Modifier le cas",
  Title: "Titre",
  "Access count": "Disponible",
  "Access count about":
    "Si vous sélectionnez l'option 'Tout le monde', la publication sera visible par tous. Si vous sélectionnez 'Par lien', vous ne pourrez la voir qu'en cliquant sur le lien direct du bouton 'Partager'.",
  "To All": "Tout le monde",
  "To Link": "Par lien",
  Publish: "Publier",
  "Publish about":
    "Lors d'une publication anonyme, votre nom et votre entreprise ne seront pas visibles par les autres utilisateurs.",
  How: "Comment",
  "As Anon": "Anonyme",
  "Case accept": "Je ne publie aucune donnée personnelle du patient.",
  "User Policy": "politique de confidentialité",
  "Remove case": "Supprimer le cas",
  "Save draft": "Enregistrer le brouillon",
  "Remove case success": "Le dossier a été supprimé avec succès",
  "Remove case error":
    "Impossible de supprimer le dossier. Veuillez réessayer ultérieurement.",
  "Update case error":
    "Impossible de mettre à jour le dossier. Veuillez réessayer ultérieurement.",
  Edit: "Modifier",
  "Cases v2": "Cas",
  sec: "seconde",
  "Confirm accept": "Confirmer accepter",
  "Remove case?": "Supprimer la série ?",
  "Upload AI": "Télécharger une étude au format DICOM",
  "Upload edu": "Téléchargez un cas au format DICOM, jpeg ou png",
  "Upload community": "Téléchargez un cas au format DICOM, jpeg ou png",
  "As anon": "Anonyme",
  status: {
    free: "Gratuit",
    subscription: "Abonnement",
    draft: "Brouillon",
    archived: "Archivé",
    completed: "Complété",
  },
  courseType: {
    course: "Cours",
    simulator: "Simulateur",
    webinar: "Webinaire",
  },
  noAcceptResult: "Décrivez ce avec quoi vous n'êtes pas d'accord",
  Meta: {
    tail: "%s | «Third Opinion»",
    tail2: " | «Third Opinion»",
    default: {
      title: "Plateforme pour les médecins",
      desc: "Plateforme médicale en ligne : une communauté de médecins, d'assistants IA, d'outils de formation au diagnostic, de cours et de ressources utiles.",
    },

    "community-cases": {
      title: "Communauté médicale",
      desc: "Communauté professionnelle en ligne de médecins - discussion de cas intéressants, de questions et partage d'expériences !",
    },
    home: {
      title: "Plateforme pour les médecins",
      desc: "Plateforme médicale en ligne : assistants IA, outils de formation au diagnostic, cours et ressources utiles pour les médecins.",
    },
    "ai-services": {
      title: "Services d'IA",
      desc: "Services d'intelligence artificielle pour le diagnostic des maladies.",
    },
    "edu-services": {
      title: "Plateforme éducative pour les médecins",
      desc: "Liste de formations et base de connaissances pour les médecins diagnostiqueurs.",
    },
  },
  "Video is unavailable": "La vidéo n'est pas disponible",
  Licence:
    '© 2026 Société à responsabilité limitée "Third Opinion Platform", INN 7714420229, OGRN 5177746328106, tous droits réservés. 121205, Moscou, Territoire du Centre d\'innovation Skolkovo, rue Nobel, 7, 2e étage, bureau 37, lieu de travail 2.',
  "Site company": "Site Web de l'entreprise",
  homepage: {
    connect: "Connectez-vous pour ",
    cost: "/mois",
    goToAI: "Études de processus",
    notAuth: {
      title: "Débloquez toutes les fonctionnalités de l'assistant IA",
      desc: "Accédez à l'assistant IA pour des mesures automatisées et la génération de rapports",
    },
    notAuthSub__off: {
      title: "Débloquez toutes les fonctionnalités de l'assistant IA",
      desc: "Accédez à l'assistant IA pour des mesures automatisées et la génération de rapports",
    },
    notAuthSub__on: {
      title: "Services d'IA pour l'analyse d'images médicales",
      desc: "Automatise les mesures et génère un rapport d'étude. Traitez 3 études gratuitement, puis… plus pour <PRICE>.",
    },
    baseSub: {
      title: "Éliminez la routine dans l'analyse de recherche grâce à l'IA",
      desc: "L'assistant IA automatise les mesures et génère des rapports en 1 clic",
    },
    notBaseSub: {
      title: "Téléchargez un scan en 1 clic",
      desc: "Utilisez l'assistant IA pour automatiser<br>les mesures et générer des rapports",
    },
  },
  "Start type": "Commencez à taper...",
  buy: "Acheter",
  more_details: "Plus de détails",
};
